import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { defaultMessages } from '../../../../libs/i18n/default';
import ReactOnRails from 'react-on-rails';
import Button from 'react-bootstrap/lib/Button';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import FormControl from 'react-bootstrap/lib/FormControl';
import Checkbox from 'react-bootstrap/lib/Checkbox';
import SelectGroup from './SelectGroup';
import CustomFormGroup from './CustomFormGroup';
import { validator, fieldsToValidate, pageValid, executeValidations } from '../../validator';
import { generateRoomElementObject, changeState } from '../../utilities';

class RoomForm extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      id: generateRoomElementObject('id', this.props.room),
      name: generateRoomElementObject('name', this.props.room),
      bathroomType: generateRoomElementObject('bathroom_type', this.props.room),
      bedType: generateRoomElementObject('bed_type', this.props.room),
      notes: generateRoomElementObject('notes', this.props.room),
      doorLock: generateRoomElementObject('door_lock', this.props.room),
      validations: {}
    };
    this.submit = this.submit.bind(this);
    this.changeState = this.changeState.bind(this);
  }

  getInitialState() {
    return({
      submitted: false
    });
  }

  componentWillMount(){
    executeValidations(this)
  }

  changeState = async(id, val) => {
    changeState(this, id, val)
  }

  submit(e){
    e.preventDefault();
    this.setState({submitted: true});
    this.props.onRoomFormSubmit(
      {
        authenticity_token: ReactOnRails.authenticityToken(),
        room: {
          id: this.state.id.val,
          name: this.state.name.val,
          bathroom_type: this.state.bathroomType.val,
          bed_type: this.state.bedType.val,
          notes: this.state.notes.val
        },
        flags: {
          door_lock: this.state.doorLock.val ? '1' : '0',
        }
      }
    );
    this.props.onClose();
  }

  render() {
    const { formatMessage } = this.props.intl;
    const { beddingOptions } = this.props;
    const bedroomTypeSelections = this.props.beddingOptions.map(function(f){
      let str = defaultMessages[`clientHostPagesRoomsFormsBedroomTypes${f.replace(/\s/g, '')}`]
      let string = str ? formatMessage(str) : f
      return [string, f]
    });
    const bathroomTypeSelections = [
      [formatMessage(defaultMessages.clientHostPagesRoomsFormsBathroomTypesShared), 'Shared'],
      [formatMessage(defaultMessages.clientHostPagesRoomsFormsBathroomTypesOwn), 'Own'],
      [formatMessage(defaultMessages.clientHostPagesRoomsFormsBathroomTypesEnsuite), 'Ensuite'],
    ];
    const ButtonTitle = this.props.room.id ? defaultMessages.clientHostPagesRoomsButtonsUpdate : defaultMessages.clientHostPagesRoomsButtonsCreate;

    return (
      <form className="signup-form">
        {
          this.props.room.id &&
          <FormControl id={'id'} type='hidden' defaultValue={this.props.room.id} />
        }

        <CustomFormGroup valid={this.state.name.valid} style={{width: '95%'}}>
          <ControlLabel>{formatMessage(defaultMessages.clientHostPagesRoomsLabelsName)}</ControlLabel>
          <FormControl
            id="name"
            placeholder={formatMessage(defaultMessages.clientHostPagesRoomsPlaceholdersName)}
            type="text"
            componentClass="input"
            defaultValue={this.state.name.val}
            onChange={e => this.changeState(e.target.id, e.target.value)} />
        </CustomFormGroup>

        <CustomFormGroup valid={this.state.notes.valid} style={{width: '95%'}}>
          <ControlLabel>{formatMessage(defaultMessages.clientHostPagesRoomsLabelsNotes)}</ControlLabel>
          <FormControl
            id="notes"
            type="text"
            componentClass="textarea"
            defaultValue={this.state.notes.val}
            onChange={e => this.changeState(e.target.id, e.target.value)} />
        </CustomFormGroup>

        <div className="row">
          <div className="col-xs-6">
            <CustomFormGroup style={{width: '90%'}}>
              <SelectGroup
                title={formatMessage(defaultMessages.clientHostPagesRoomsLabelsBathroomTypes)}
                setId={'bathroomType'}
                valid={this.state.bathroomType.valid}
                placeholder={formatMessage(defaultMessages.clientHostPagesRoomsPlaceholdersBathroomTypes)}
                options={bathroomTypeSelections}
                defaultValue={this.state.bathroomType.val}
                controlFunc={e => this.changeState(e.target.id, e.target.value)} />
            </CustomFormGroup>
          </div>


          <div className="col-xs-6">
            <CustomFormGroup style={{width: '90%'}}>
              <SelectGroup
                title={formatMessage(defaultMessages.clientHostPagesRoomsLabelsBedroomTypes)}
                setId={'bedType'}
                valid={this.state.bedType.valid}
                placeholder={formatMessage(defaultMessages.clientHostPagesRoomsPlaceholdersBedroomTypes)}
                controlFunc={this.handleFormItemSelection}
                options={bedroomTypeSelections}
                defaultValue={this.state.bedType.val}
                controlFunc={e => this.changeState(e.target.id, e.target.value)} />
            </CustomFormGroup>
          </div>
        </div>

        <Checkbox
          checked={this.state.doorLock.val}
          id='doorLock'
          onChange={e => this.changeState(e.target.id, !this.state.doorLock.val)}>
          {formatMessage(defaultMessages.clientHostPagesRoomsLabelsDoorLock)}
        </Checkbox>

        <Button
          id="room-submit"
          className="btn-primary"
          onClick={this.submit}
          disabled={!pageValid(this.state, this.props.requiredFields)} >
            {formatMessage(ButtonTitle)}
        </Button>
      </form>
    );
  }
}

RoomForm.propTypes = {
   onHostProfileSubmit: PropTypes.func,
   onSkipSubmit: PropTypes.func,
   onGoBack: PropTypes.func,
   page: PropTypes.string,
   intl: PropTypes.object,
   content: PropTypes.object
};

export default injectIntl(RoomForm);
